import { useEffect } from 'react'
import { useQuery } from '@apollo/client'
import { HealthDataReport } from '@src/types'
import { HealthDataReportQuery } from '@screens/Nora/graphql/healthDataReport.generated.ts'
import { HEALTH_DATA_REPORT } from '@screens/Nora/graphql/healthDataReport.ts'
import { POLLING_REPORT_STATES } from '@screens/Nora/constants.ts'

const POLLING_INTERVAL = 5000 // 5 seconds
const TOTAL_POLLING_DURATION = 2 * 60 * 1000 // 2 minutes

interface PollReportParams {
  report: HealthDataReport | null
}

export const usePollReport = ({ report: reportFromProps }: PollReportParams) => {
  const { data: healthDataReportData, stopPolling } = useQuery<HealthDataReportQuery>(
    HEALTH_DATA_REPORT,
    {
      skip: !reportFromProps || !POLLING_REPORT_STATES.includes(reportFromProps.lastState.kind),
      pollInterval: POLLING_INTERVAL,
      variables: {
        id: reportFromProps?.id,
      },
    },
  )

  const report = healthDataReportData?.healthDataReport || reportFromProps
  const loading = report ? POLLING_REPORT_STATES.includes(report.lastState.kind) : false

  if (!loading) {
    stopPolling()
  }

  useEffect(() => {
    const timeoutHandle = setTimeout(() => {
      stopPolling()
    }, TOTAL_POLLING_DURATION)

    return () => {
      stopPolling()
      clearTimeout(timeoutHandle)
    }
  }, [stopPolling])

  return {
    report: report as HealthDataReport | null,
    loading,
  }
}
